Ext.define('SA.data.Ranking', {
    alias: 'view.ranking',
    extend: 'SA.data.ReportView',

    mixins: {
        filterable: 'SA.data.mixin.Filterable',
        locations: 'SA.data.mixin.OneLocation'
    },

    statics: {
        create({project, censusRelease, name, locationItems, attributes, geographicUnit = null}) {
            var data = {
                type: 'childTable',
                attributes: attributes.filter(id => this.supportsAttribute(id)),
                buildingBlocksCensusRelease: censusRelease,
                filterVisibility: 'strikeout',
                geographicUnit,
                locationItems: Ext.Array.from(locationItems[0]),
                maximumChildren: 100,
                name,
                sort: ['asc', 'name']
            };

            return new SA.data.Ranking({project, data});
        },

        supportsAttribute(attribute) {
            return SA.data.AttributesCache.isPolygonAttribute(attribute);
        }
    },

    hasNoAttributeInLocationGeographicReleases() {
        var location = this.getLocation(),
            attributes = this.getAttributes();

        return SA.data.DataModel.noAttributeInLocationGeographicReleases({location, attributes});
    },

    attributesHaveNoCommonUnits() {
        var units = SA.data.GeographicUnits.getAllowedIdsForAttributes(this.getAttributes());

        return !units.length;
    },

    canSelectGeographicUnit() {
        return !!this.getAllowedGeographicUnits().length;
    },

    createController() {
        return new SA.RankingController(this);
    },

    createDataMap() {
        this.syncGeographicReleases();
        this.syncGeographicUnits();

        return new SA.data.Ranking.DataMap({
            geographicReleases: this.geographicReleases,
            filter: this.getFilterVisibility() === 'hide' ? this.getFilterQuery() : null,
            geographicUnit: this.getGeographicUnit(),
            location: this.getQueryLocation(),
            size: this.getMaximumChildren(),
            sort: this.getSort()
        });
    },

    getAllowedGeographicUnits() {
        var location = this.getLocation(),
            attributes = this.getAttributes(),
            geoUnitsFilter = this.getDiscoverableOrSelectedGeoUnits();

        return SA.data.DataModel.getAllowedGeoUnitsForRanking({location, attributes, geoUnitsFilter});
    },

    getDatasetsWithNoMatchingUnitsForLocation() {
        var location = this.getLocation(),
            attributes = this.getAttributes();

        return SA.data.DataModel.getDatasetsWithNoMatchingUnitsForLocation({location, attributes});
    },

    getDiscoverableOrSelectedGeoUnits() {
        var {clean, unique} = Ext.Array;

        return clean(unique([this.getGeographicUnit(), ...this.getDiscoverableGeoUnits()]));
    },

    getExportQuery() {
        var attributes = this.getAttributes(),
            baseColumns = ['name', 'spatialId'],
            country = this.getCountry(),
            filter = this.getFilterQuery(),
            filterVisibility = this.getFilterVisibility(),
            geographicUnit = this.getGeographicUnit(),
            columns = SA.Exports.getColumnExpressions({attributes, baseColumns, country, filter, filterVisibility, geographicUnit});

        return this.getDataMap().createQueryConfig(columns);
    },

    getReportData(cfg) {
        var fn = cfg.fn,
            scope = cfg.scope,
            run = this.syncGeographicUnits() && this.syncGeographicReleases(),
            map = this.getDataMap(),
            filter = this.getFilterQuery(),
            derived;

        if (filter && this.getFilterVisibility() === 'strikeout') {
            derived = this.getStrikeoutFilterDerivedAttribute(filter);
        }

        map.ensure({
            attributes: this.getAttributes(),
            derivedAttributes: derived,
            run, 

            fn,
            scope
        });

        return map.getData();
    },

    getGeographicUnit() {
        return this.data.geographicUnit;
    },

    getMaximumChildren() {
        return this.data.maximumChildren;
    },

    getRowCount() {
        return Math.min(this.getMaximumChildren(), this.getDataMap().getNumberOfAvailableResultsUpTo10001());
    },

    getSort() {
        var data = this.data;

        if (!data.sort) {
            this.setSort(null);
        }

        return data.sort;
    },

    getSortAttribute() {
        return this.getSort()[1];
    },

    getSortDirection() {
        return this.getSort()[0];
    },

    getType() {
        return 'ranking';
    },

    hasMoreResultsAvailableThanDisplayed() {
        return this.getDataMap().getNumberOfAvailableResultsUpTo10001() > this.getMaximumChildren();
    },

    isReportDataLoading() {
        return !this.getDataMap().hasRetrievedNumberOfAvailableResultsUpTo10001();
    },

    isSavable() {
        return this.getLocation() && this.getAttributes().length && this.canSelectGeographicUnit();
    },

    removeAttributeImpl(attribute) {
        this.callParent([attribute]);

        if (attribute === this.getSortAttribute()) {
            this.setSort(null);
        }

        this.auditFilter();
    },

    setAttributesImpl(attributes) {
        this.mixins.attributes.setAttributesImpl.call(this, attributes);

        this.syncGeographicUnits();
    },

    setFilterImpl(filter) {
        var changed = this.mixins.filterable.setFilterImpl.call(this, filter);

        if (changed) {
            if (this.getFilterVisibility() === 'hide') {
                this.clearDataMap();
            }
            else {
                this.getDataMap().removeAttribute('filter');
            }
        }

        return changed;
    },

    setFilterVisibilityImpl(filterVisibility) {
        var oldVisibility = this.getFilterVisibility(),
            changed = this.mixins.filterable.setFilterVisibilityImpl.call(this, filterVisibility);

        if (changed && (oldVisibility === 'hide' || filterVisibility === 'hide')) {
            this.clearDataMap();
        }

        return changed;
    },

    setGeographicUnit(geographicUnit) {
        if (this.set('geographicUnit', geographicUnit)) {
            this.clearDataMap();
            this.fireEvent('change:geographicUnit', this);
        }
    },

    setLocationImpl(location) {
        this.mixins.locations.setLocationImpl.call(this, location);

        this.syncGeographicUnits();
        this.clearDataMap();

        if (location) {
            this.project.addLocation(location);
        }
    },

    setMaximumChildren(maxChildren) {
        if (this.set('maximumChildren', maxChildren)) {
            this.getDataMap().setSize(maxChildren);
            this.fireEvent('change:maximumChildren', this);
        }
    },

    setSort(attribute, direction) {
        var oldSort = this.data.sort,
            sort;

        if (!attribute) {
            attribute = this.getAttributes()[0] || 'name';
        }
        else if (Array.isArray(attribute)) {
            direction = attribute[0];
            attribute = attribute[1];
        }



                if (!direction) {
            if (oldSort && oldSort[1] === attribute) {
                return;
            }

            direction = attribute === 'name' ? 'asc' : 'desc';
        }

        sort = [direction, attribute];

        if (SA.Json.differ(sort, oldSort)) {
            this.set('sort', sort);
            this.clearDataMap();
            this.fireEvent('change:sort', this);
        }
    },

    syncGeographicReleases() {
        var releases = SA.data.AttributesCache.getGeographicReleasesForAttributes(this.getAttributes()).sort();

        if (SA.Json.differ(this.geographicReleases, releases)) {
            this.geographicReleases = releases;

            this.clearDataMap();
        }

        return true;
    },

    syncGeographicUnits() {
        var allowedUnits = Ext.Array.pluck(this.getAllowedGeographicUnits(), 'id');

        if (allowedUnits.length === 0) {
            return false;
        }

        if (!allowedUnits.includes(this.getGeographicUnit())) {
            let first = allowedUnits[0],
                second = allowedUnits[1],
                locationUnit = SA.data.LocationsCache.getGeographicUnit(this.getLocation());

            this.setGeographicUnit((first === locationUnit && !!second) ? second : first);
        }

        return true;
    }
});